export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6981.ef7c8fe7.jpg";